module.exports = __webpack_public_path__ + "static/media/Parma.40a90e27.png";